// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"e36dfc5b","8915":"e80da2aa","9352":"5ab57526"}[chunkId] + ".chunk.css";
};